module.exports = __webpack_public_path__ + "static/media/AI.ab7d4b9a.svg";